// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image[data-v-576208ef] {\n  width: 160px;\n  height: 160px;\n}\n", ""]);
// Exports
module.exports = exports;
